module.exports = __webpack_public_path__ + "img/fma.696752ad.jpg";